import { FC } from "react";
import "./styles.scss";

interface IProps {
  language: string;
  onChange: (language: string) => void;
}

const OPTIONS: Record<string, { value: string; label: string }> = {
  en: { value: "he", label: "עברית" },
  he: { value: "en", label: "English" },
};

export const LanguageToggle: FC<IProps> = ({ language, onChange }) => {
  const other = OPTIONS[language] ?? OPTIONS.en;

  return (
    <button
      type="button"
      className="landing-language-toggle"
      onClick={() => onChange(other.value)}
    >
      {other.label}
    </button>
  );
};
